type StampFields = { width?: number; floods?: number }

export default function getMaxWidthOfMaterial(stamp: StampFields) {
    const { width, floods } = stamp

    if (!width || !floods) return

    return width * floods + (floods - 1) * 4 + 12
}
